import { NavLink } from "react-router-dom";
import { Nav, NavItem } from "react-bootstrap";
import "./NavButtonCollection.css"
import { useEffect, useState } from "react";
import { groupAccess, loginRequest } from "../../../utilities/authConfig";
import { useMsal } from "@azure/msal-react";
import { AuthenticationResult, InteractionRequiredAuthError } from "@azure/msal-browser";
import { checkGroupsInStorage, getGroupsFromStorage, setGroupsInStorage } from "../../../utilities/StorageUtils";

interface IdTokenClaims {
  groups?: string[];
}

const NavButtonCollection = () => {
  const { instance, accounts } = useMsal();
  const [userGroups, setUserGroups] = useState<string[]>([]);

  useEffect(() => {
    if (accounts.length > 0) {
      const activeAccount = instance.getActiveAccount() || instance.getAllAccounts()[0];

      if (checkGroupsInStorage(activeAccount)) {
        const claimedGroups = getGroupsFromStorage(activeAccount);
        if (claimedGroups) {
          setUserGroups(claimedGroups);
          return;
        }
      }

      const request = {
        ...loginRequest,
        account: activeAccount,
      };

      instance.acquireTokenSilent(request).then((response: AuthenticationResult) => {
        const idTokenClaims = response.idTokenClaims as IdTokenClaims;
        if (idTokenClaims.groups) {
          setUserGroups(idTokenClaims.groups);
          setGroupsInStorage(request.account, idTokenClaims.groups);
        }
      }).catch((error: any) => {
        if (error instanceof InteractionRequiredAuthError) {
          instance.acquireTokenRedirect(request);
        } else {
          console.error(error);
        }
      });
    }
  }, [instance, accounts]);

  const hasGroup = (requiredGroups: string[]): boolean =>
    requiredGroups.some((group) => userGroups.includes(group));
  
  return (
    <Nav className="d-flex justify-content-start align-items-center mb-6 ps-0 pe-0 fs-4">
      {hasGroup([groupAccess.admin, groupAccess.arbetsledning]) && (
        <NavLink to="/createproject" className="nav-link">
          <NavItem className="nav-item">Skapa Projekt</NavItem>
        </NavLink>
      )}
      {hasGroup([groupAccess.admin, groupAccess.arbetsledning, groupAccess.worker]) && (
        <NavLink to="/projects" className="nav-link">
          <NavItem className="nav-item">Alla Projekt</NavItem>
        </NavLink>
      )}
      {hasGroup([groupAccess.admin, groupAccess.arbetsledning, groupAccess.worker]) && (
        <NavLink to="/myProjects" className="nav-link">
          <NavItem className="nav-item">Mina Projekt</NavItem>
        </NavLink>
      )}
      {/* Not implemented. User access to the application is managed by the groups in Azure AD.
      {hasGroup([groupAccess.admin]) && (
        <NavLink to="/handleaccounts" className="nav-link">
          <NavItem className="nav-item">Hantera Konton</NavItem>
        </NavLink>
      )} */}
    </Nav>
  );
};
export default NavButtonCollection;